import { GridRowProps } from '@mui/x-data-grid';

import { isBefore } from 'date-fns';
import { useTranslation } from 'react-i18next';

import { GridRowWithTooltip } from 'app/components/GridRowWithTooltip';
import { translations } from 'locales/i18n';

export const BookingRowWithTooltipEndTimeOverdue = (params: GridRowProps) => {
  const { t } = useTranslation();
  return params.row.deletedAt !== null ? (
    <GridRowWithTooltip
      {...params}
      tooltip={t(translations.pages.leihbar.tooltips.bookingCanceled())}
    />
  ) : (
    <GridRowWithTooltip
      {...params}
      tooltip={
        isBefore(new Date(params.row.endTime), new Date()) && params.row.state === 'PICKED'
          ? t(translations.pages.leihbar.tooltips.endTimeOverdue())
          : ''
      }
    />
  );
};
